import React from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import Card from '../Card';
import Icon from '../Icon';

import styles from './ExpandableCard.module.scss';

const ExpandableCard = ({ children, title, sideTitle = null, icon = null }) => {
	return (
		<Accordion.Root type="single" collapsible>
			<Accordion.Item value={title}>
				<Card className={styles.card}>
					<Accordion.Trigger className={styles.title}>
						<Card.Title>
							{icon}
							{title}
						</Card.Title>
						<span className={styles.sideTitle}>{sideTitle}</span>
						<Icon>chevron_right</Icon>
					</Accordion.Trigger>
					<Accordion.Content>{children}</Accordion.Content>
				</Card>
			</Accordion.Item>
		</Accordion.Root>
	);
};

const Root = ({ children, value }) => {
	return (
		<Accordion.Root type="single" collapsible>
			<Accordion.Item value={value}>
				<Card className={styles.card}>{children}</Card>
			</Accordion.Item>
		</Accordion.Root>
	);
};

const Content = ({ children }) => {
	return <Accordion.Content>{children}</Accordion.Content>;
};

const Title = ({ icon = null, children, sideTitle = null }) => {
	return (
		<Accordion.Trigger className={styles.title}>
			<Card.Title>
				{icon}
				{children}
			</Card.Title>
			<span className={styles.sideTitle}>{sideTitle}</span>
			<Icon>chevron_right</Icon>
		</Accordion.Trigger>
	);
};

ExpandableCard.Root = Root;
ExpandableCard.Title = Title;
ExpandableCard.Content = Content;

export default ExpandableCard;
